import React from 'react';
import { Check } from 'lucide-react';

interface PlanProps {
  short_name: string;
  price: string;
  features: string[];
  isPopular?: boolean;
  loading: boolean;
  error?: string | null;
  onSelect: () => Promise<void>;
}

export default function Plan({ 
  short_name, 
  price, 
  features, 
  isPopular, 
  loading,
  error,
  onSelect 
}: PlanProps) {
  const handleClick = async () => {
    try {
      await onSelect();
    } catch (err) {
      // Error handling is managed by parent component
      console.error('Plan selection error:', err);
    }
  };

  return (
    <div className={`border rounded-lg shadow-sm p-8 ${
      isPopular ? 'border-blue-500 ring-1 ring-blue-500' : ''
    }`}>
      <h3 className="text-2xl text-gray-900 flex items-center">
        {short_name}
        {isPopular && (
          <span className="inline-block px-2 py-1 ml-2 text-sm font-semibold text-blue-600 bg-blue-50 rounded-full">
            Most Popular
          </span>
        )}
      </h3>
      <p className="mt-4 text-4xl font-bold">${price}</p>
      <p className="text-gray-500">one-time payment</p>
      
      <button
        onClick={handleClick}
        disabled={loading}
        className={`mt-8 block w-full text-center py-3 rounded-md transition-colors ${
          isPopular
            ? 'bg-blue-600 text-white hover:bg-blue-700 disabled:bg-blue-400'
            : 'bg-white text-blue-600 border-2 border-blue-600 hover:bg-blue-50 disabled:bg-gray-100 disabled:border-gray-300 disabled:text-gray-500'
        }`}
      >
        {loading ? 'Processing...' : 'Get Started'}
      </button>

      <ul className="mt-6 space-y-4">
        {features.map((feature) => (
          <li key={feature} className="flex items-center">
            <Check className="h-5 w-5 text-green-500 mr-2" style={{ minWidth: '24px', minHeight: '24px' }} />
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      <p className="mt-4 text-center text-sm text-gray-500"><a href="#compare-all-benefits" className="text-blue-500">See all features</a></p>
      {error && (
        <p className="mt-4 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
}